import { Card, CardContent } from '@mui/material';
import Typography from '@mui/material/Typography';
import { jsx, jsxs } from 'react/jsx-runtime';

// src/til/post-detail-page/metadata.tsx
var PostMetadata = (props) => {
  const { title, readTimeInMinutes, sx } = props;
  return /* @__PURE__ */ jsx(Card, { sx, children: /* @__PURE__ */ jsxs(CardContent, { children: [
    /* @__PURE__ */ jsx(Typography, { variant: "h4", component: "h1", gutterBottom: true, fontWeight: "bold", children: title }),
    /* @__PURE__ */ jsxs(Typography, { gutterBottom: true, children: [
      readTimeInMinutes,
      " min read"
    ] })
  ] }) });
};

export { PostMetadata };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-GJOKMKN7.mjs.map